<template>
  <v-form
    ref="login-form"
    v-model="valid"
    lazy-validation
    class="login-form d-flex"
    @submit.prevent="onSubmit"
    id="login-form"
  >
    <div class="login-form-main pa-4 justify-center">
      <h1 class="text-center font-weight-bold mb-10 mt-4">
        <translate>Sign in</translate>
      </h1>

      <label class="titleForm d-flex pb-2"><translate>Email</translate></label>
      <v-text-field
        v-model="formData.email"
        :rules="emptyRules"
        solo
        outlined
        flat
        required
        class="mb-2"
      ></v-text-field>
      <label class="titleForm d-flex pb-2">
        <translate>Password</translate>
        <router-link :to="{name: 'forgot'}" class="ml-auto text-decoration-none">
          <translate>Forgot password?</translate>
        </router-link>
      </label>
      <v-text-field
        v-model="formData.password"
        :rules="emptyRules"
        type="password"
        solo
        outlined
        flat
        required
        class="mb-2"
      ></v-text-field>

      <v-alert v-if="messageError" dense text type="error">
        {{ messageError }}
      </v-alert>

      <div class="text-center">
        <div class="mb-8">
          <b>
            <span><translate>Not a member?</translate> </span>
            <router-link :to="{name: 'register'}" class="text-decoration-none ml-1">
              <translate>Sign up now</translate>
            </router-link>
          </b>
        </div>
        <v-btn
          large
          color="primary"
          class="text-none subtitle-1 font-weight-bold rounded-0"
          type="submit"
          form="login-form"
          width="200"
          min-height="58"
        >
          <translate>Sign In</translate>
        </v-btn>
      </div>
    </div>
  </v-form>
</template>
<script>
import { mapActions } from "vuex";
import Vue from 'vue';
export default {
  name: "FormRegistMember",
  data: () => ({
    messageError: "",
    valid: true,
    emptyRules: [
      (v) => !!v || Vue.prototype.$gettext("Field is required"),
      // v => (v && v.length <= 10) || 'Field must be less than 10 characters',
    ],
    formData: {
      email: "",
      password: "",
    },
  }),
  methods: {
    ...mapActions({
      login: "login",
    }),
    async onSubmit() {
      console.log("submit");
      let vm = this;
      if (vm.$refs["login-form"].validate()) {
        // console.log("submit", vm.formData);
        const message = await vm.login(vm.formData);
        console.log(message);
        if (message) {
          vm.messageError = message;
        } else {
          vm.$router.push(
            vm.$router.history.current.query.redirect || {
              name: "homepage",
            }
          );
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.login-form {
  background: #f2f3f5;
  width: 100%;
  min-height: 100vh;
  height: 100%;
  align-items: center;
}
.login-form-main {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}
.login-form-main > h1 {
  font-size: 2.5rem;
  text-transform: uppercase;
  font-weight: bolder;
}
</style>
